// import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//     benefitList : [],
//     error: null,
//     loading: false
// }

// const benefitSlice = createSlice({
//     name: "benefits",
//     initialState,
//     reducers: {
//         setBenefitList : (state, action)=>{
//             state.benefitList = action.payload
//             state.error = null
//             state.loading = false
//         },
//         addBenefit : (state, action)=>{
//             state.benefitList.push(action.payload)
//         },
//         removeBenefit : (state, action)=>{
//             state.benefitList.filter(eachList=>eachList._id !== action.payload._id)
//         },
//     }
// })

// export const { setBenefitList, addBenefit, removeBenefit } = benefitSlice.actions

// export default benefitSlice.reducer




import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  benefitList: [],
  error: null,
  loading: false,
};

const benefitSlice = createSlice({
  name: "benefits",
  initialState,
  reducers: {
    setBenefitList: (state, action) => {
      state.benefitList = action.payload;
      state.error = null;
      state.loading = false;
    },
    addBenefit: (state, action) => {
      state.benefitList.push(action.payload);
    },
    updateBenefit: (state, action) => {
      const index = state.benefitList.findIndex(b => b._id === action.payload._id);
      if (index !== -1) state.benefitList[index] = action.payload;
    },
    removeBenefit: (state, action) => {
      state.benefitList = state.benefitList.filter(b => b._id !== action.payload._id);
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { setBenefitList, addBenefit, updateBenefit, removeBenefit, setLoading, setError } = benefitSlice.actions;

export default benefitSlice.reducer;